import { render, staticRenderFns } from "./CommunityBell.vue?vue&type=template&id=a0a04b70&scoped=true&"
import script from "./CommunityBell.vue?vue&type=script&lang=js&"
export * from "./CommunityBell.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBell.vue?vue&type=style&index=0&id=a0a04b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a04b70",
  null
  
)

export default component.exports